import { Panel } from '@/app/components/Panel';
import { ActionControl } from '@/app/components/ActionControl';
import { ClearanceForm } from '@/app/components/ClearanceForm';
import { CoReleaseCredit } from '@/app/components/CoReleaseCredit';
import { LightboxImage } from '@/app/components/LightboxImage';
import { PageMain } from '@/app/components/PageFrame';
import { YoutubeEmbed } from '@/app/components/YoutubeEmbed';
import { bikiniFeature, hcwFeature } from '@/app/data/featured';
import { useLang } from '@/app/hooks/useLang';
import { BIKINI_RELEASE_ID, CD_CHECKOUT_URL, HCW_RELEASE_ID } from '@/app/lib/constants';

export function Home() {
  const { t } = useLang();
  const bikiniRelease = bikiniFeature;
  const upcomingRelease = hcwFeature;
  const videoThumbs = bikiniFeature.videos;

  return (
    <PageMain>
      {bikiniRelease && (
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl mb-4 tracking-[0.08em] uppercase">{t('home.payload')}</h2>
          <Panel>
            <div className="grid gap-6 md:grid-cols-2 md:items-start">
              {bikiniRelease.coverImage && (
                <LightboxImage
                  src={bikiniRelease.coverImage}
                  alt="Bikini Atoll Broadcast front cover"
                  className="w-full"
                  imageClassName="w-full aspect-square object-cover"
                  width={bikiniRelease.coverWidth}
                  height={bikiniRelease.coverHeight}
                  priority
                />
              )}
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-bold">FATAL EXPOSURE: Bikini Atoll Broadcast</p>
                  <p className="mt-1 text-xs uppercase tracking-[0.18em]">OUT NOW</p>
                </div>
                <div className="flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap">
                  <ActionControl
                    href={CD_CHECKOUT_URL}
                    label={t('action.acquireUnit')}
                    plain={t('action.buycd')}
                    className="buy-cd-cta"
                  />
                  {bikiniRelease.externalUrl && (
                    <ActionControl
                      href={bikiniRelease.externalUrl}
                      label={t('action.intercept')}
                      plain={t('action.listenBandcamp')}
                    />
                  )}
                  <ActionControl
                    to={`/releases/${BIKINI_RELEASE_ID}`}
                    label={t('action.openFile')}
                    plain={t('action.releaseFile')}
                  />
                </div>
                <div className="space-y-1 text-xs dim">
                  <p>{t('home.printRun')}</p>
                  <p>{t('home.bundle')}</p>
                  <p>{t('home.duration')}</p>
                </div>
                <div className="space-y-2">
                  <p className="doc-body">{t('home.assessmentLead')}</p>
                  <p className="doc-body">{t('home.assessmentBody')}</p>
                  <CoReleaseCredit />
                </div>
              </div>
            </div>
          </Panel>
        </section>
      )}

      {upcomingRelease && (
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl mb-4 tracking-[0.08em] uppercase">
            {t('home.incomingTransmission')}
          </h2>
          <Panel>
            <div className="grid gap-6 md:grid-cols-2 md:items-start">
              {upcomingRelease.coverImage && (
                <div>
                  <LightboxImage
                    src={upcomingRelease.coverImage}
                    alt="The Human Crust of War cover"
                    className="w-full"
                    imageClassName="w-full object-cover"
                    width={upcomingRelease.coverWidth}
                    height={upcomingRelease.coverHeight}
                  />
                  {upcomingRelease.id === HCW_RELEASE_ID && (
                    <p className="mt-2 text-xs dim">{t('release.coverSpeculative')}</p>
                  )}
                </div>
              )}
              <div className="space-y-4">
              <div className="space-y-3">
                <p className="text-sm font-bold tracking-[0.04em]">{t('home.nsr02Title')}</p>
                <p className="text-xs dim">{t('home.nsr02Credit')}</p>
                <p className="doc-body">{t('home.nsr02Lead')}</p>
                <p className="doc-body">{t('home.nsr02Body')}</p>
                <p className="doc-body">{t('home.nsr02Close')}</p>
                <blockquote className="border-l border-[var(--color-term)] pl-3">
                  <p className="doc-body">{t('home.nsr02Quote')}</p>
                  <p className="mt-1 text-xs dim">{t('home.nsr02QuoteBy')}</p>
                </blockquote>
              </div>
                <ClearanceForm />
                <ActionControl
                  to={`/releases/${upcomingRelease.id}`}
                  label={t('action.openFile')}
                  plain={t('action.releaseFile')}
                />
              </div>
            </div>
          </Panel>
        </section>
      )}

      {videoThumbs.length > 0 && (
        <section className="mb-12">
          <h2 className="text-3xl md:text-4xl mb-4 tracking-[0.08em] uppercase">{t('home.footage')}</h2>
          <Panel>
            <div className="grid md:grid-cols-2 gap-4">
              {videoThumbs.map((video) => (
                <YoutubeEmbed
                  key={video.url}
                  url={video.url}
                  title={video.title}
                  poster={video.poster}
                  width={video.posterWidth}
                  height={video.posterHeight}
                />
              ))}
            </div>
          </Panel>
        </section>
      )}
    </PageMain>
  );
}
